<template>
  <div class="cost-bill-check-page">
    <div class="filter-area">
      <el-form :inline="true" :label-width="'80px'" class="filter-form">
        <el-form-item label="物流商">
          <el-select v-model="filterForm.transportCode" placeholder="请选择物流商" style="width: 180px;">
            <el-option label="顺丰快递" value="SF" />
            <el-option label="圆通快递" value="YTO" />
            <el-option label="中通快递" value="ZTO" />
            <el-option label="京东快递" value="JD" />
          </el-select>
        </el-form-item>
        <el-form-item label="账单周期">
          <el-date-picker
            v-model="filterForm.billCycle"
            type="month"
            placeholder="选择月份"
            format="yyyy-MM"
            value-format="yyyy-MM"
            style="width: 150px;"
          />
        </el-form-item>
        <el-form-item label="单据状态">
          <el-select v-model="filterForm.billStatus" placeholder="请选择状态" style="width: 150px;">
            <el-option label="无差异" value="无差异" />
            <el-option label="有差异已处理" value="有差异已处理" />
            <el-option label="有差异待处理" value="有差异待处理" />
          </el-select>
        </el-form-item>
        <el-form-item label="核对单号">
          <el-input v-model="filterForm.checkBillNo" placeholder="请输入核对单号" style="width: 200px;" />
        </el-form-item>
        <el-form-item label="月结账号">
          <el-input v-model="filterForm.monthlyAccount" placeholder="请输入月结账号" style="width: 180px;" />
        </el-form-item>
        <el-form-item label="快递单号">
          <el-input v-model="filterForm.expressNumber" placeholder="请输入快递单号" style="width: 200px;" />
        </el-form-item>
        <el-form-item label="差异原因">
          <el-select v-model="filterForm.diffReason" placeholder="请选择差异原因" style="width: 180px;">
            <el-option label="结算系统不存在" value="结算系统不存在" />
            <el-option label="非宝尊月结" value="非宝尊月结" />
            <el-option label="产品类型差异" value="产品类型差异" />
            <el-option label="运单卡接口" value="运单卡接口" />
          </el-select>
        </el-form-item>
        <div class="filter-actions">
          <el-button type="text" icon="el-icon-arrow-down" @click="toggleFilterExpand">
            {{ filterExpanded ? '收起' : '展开' }}
          </el-button>
          <el-button class="icon-button" icon="el-icon-setting" />
          <el-button @click="handleReset">重置</el-button>
          <el-button type="primary" @click="handleSearch">搜索</el-button>
        </div>
      </el-form>
    </div>

    <div class="action-bar">
      <div class="action-bar__left">
        <el-button
          type="primary"
          icon="el-icon-refresh"
          :disabled="!selectedBillNos.length"
          @click="handleReMatch"
        >
          重新匹配
        </el-button>
        <el-button
          icon="el-icon-file-text"
          @click="handleImportExportResult"
        >
          导入导出结果
        </el-button>
      </div>
      <div class="action-bar__right">
        <el-button icon="el-icon-upload2" @click="handleImport">导入</el-button>
        <el-button icon="el-icon-download" @click="handleExport">导出</el-button>
        <el-button class="icon-button" icon="el-icon-setting" />
      </div>
    </div>

    <div class="bill-list-area">
      <el-table
        :data="billList"
        border
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="50" />
        <el-table-column
          prop="matchResult"
          label="匹配结果"
          width="100"
        />
        <el-table-column
          prop="checkBillNo"
          label="核对单号"
          width="180"
        />
        <el-table-column
          prop="billCycle"
          label="账单周期"
          width="120"
        />
        <el-table-column
          prop="monthlyAccount"
          label="月结账号"
          width="140"
        />
        <el-table-column
          prop="transportCode"
          label="物流商编码"
          width="100"
        />
        <el-table-column
          prop="transportName"
          label="物流商名称"
          width="120"
        />
        <el-table-column
          prop="transportOrderCount"
          label="物流商单量"
          width="100"
        />
        <el-table-column
          prop="systemOrderCount"
          label="系统单量"
          width="100"
        />
        <el-table-column
          prop="billStatus"
          label="单据状态"
          width="120"
        >
          <template slot-scope="scope">
            <el-tag :type="getStatusType(scope.row.billStatus)">
              {{ scope.row.billStatus }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="transportStandardFee"
          label="物流商标准运费合计"
          width="140"
          :formatter="formatCurrency"
        />
        <el-table-column
          prop="systemStandardFee"
          label="系统标准运费合计"
          width="140"
          :formatter="formatCurrency"
        />
        <el-table-column
          prop="standardFeeDiff"
          label="标准运费差异合计"
          width="140"
          :formatter="formatCurrencyWithColor"
        />
        <el-table-column
          label="操作"
          width="100"
        >
          <template slot-scope="scope">
            <el-button type="text" class="action-link" @click="viewDetail(scope.row)">
              查看明细
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-area">
        <div class="page-size-selector">
          <span>每页</span>
          <el-select v-model="pagination.pageSize" size="small" style="width: 60px;">
            <el-option :label="'20'" :value="20" />
            <el-option :label="'30'" :value="30" />
            <el-option :label="'50'" :value="50" />
          </el-select>
          <span>条</span>
        </div>
        <div class="pagination">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pagination.currentPage"
            :page-size="pagination.pageSize"
            layout="prev, pager, next, jumper"
            :total="pagination.total"
          />
        </div>
        <div class="total-info">
          共 {{ pagination.total }} 条
        </div>
      </div>
    </div>

    <el-dialog
      v-model="detailDialogVisible"
      title="查看成本账单明细"
      width="90%"
      :close-on-click-modal="false"
    >
      <div class="bill-detail">
        <div class="detail-section">
          <div class="section-header">
            <span class="section-title">成本账单信息</span>
            <el-button type="text" icon="el-icon-arrow-up" @click="toggleDetailSection('billInfo')" />
          </div>
          <div v-show="detailSections.billInfo" class="section-content">
            <div class="info-grid">
              <div class="info-item">
                <span class="info-label">核对单号</span>
                <span class="info-value">{{ currentBill.checkBillNo }}</span>
              </div>
              <div class="info-item">
                <span class="info-label">账单周期</span>
                <span class="info-value">{{ currentBill.billCycle }}</span>
              </div>
              <div class="info-item">
                <span class="info-label">月结账号</span>
                <span class="info-value">{{ currentBill.monthlyAccount }}</span>
              </div>
              <div class="info-item">
                <span class="info-label">物流商编码</span>
                <span class="info-value">{{ currentBill.transportCode }}</span>
              </div>
              <div class="info-item">
                <span class="info-label">物流商名称</span>
                <span class="info-value">{{ currentBill.transportName }}</span>
              </div>
              <div class="info-item">
                <span class="info-label">物流商单量</span>
                <span class="info-value">{{ currentBill.transportOrderCount }}</span>
              </div>
              <div class="info-item">
                <span class="info-label">系统单量</span>
                <span class="info-value">{{ currentBill.systemOrderCount }}</span>
              </div>
              <div class="info-item">
                <span class="info-label">物流商标准运费</span>
                <span class="info-value">{{ formatCurrency(currentBill.transportStandardFee) }}</span>
              </div>
              <div class="info-item">
                <span class="info-label">系统标准运费</span>
                <span class="info-value">{{ formatCurrency(currentBill.systemStandardFee) }}</span>
              </div>
              <div class="info-item">
                <span class="info-label">标准运费差异</span>
                <span class="info-value">{{ formatCurrency(currentBill.standardFeeDiff) }}</span>
              </div>
              <div class="info-item">
                <span class="info-label">物流商折后运费</span>
                <span class="info-value">{{ formatCurrency(currentBill.transportDiscountedFee) }}</span>
              </div>
              <div class="info-item">
                <span class="info-label">系统折后运费</span>
                <span class="info-value">{{ formatCurrency(currentBill.systemDiscountedFee) }}</span>
              </div>
              <div class="info-item">
                <span class="info-label">折后运费差异</span>
                <span class="info-value">{{ formatCurrency(currentBill.discountedFeeDiff) }}</span>
              </div>
              <div class="info-item">
                <span class="info-label">物流商总费用</span>
                <span class="info-value">{{ formatCurrency(currentBill.transportTotalFee) }}</span>
              </div>
              <div class="info-item">
                <span class="info-label">系统总费用</span>
                <span class="info-value">{{ formatCurrency(currentBill.systemTotalFee) }}</span>
              </div>
              <div class="info-item">
                <span class="info-label">总费用差异</span>
                <span class="info-value">{{ formatCurrency(currentBill.totalFeeDiff) }}</span>
              </div>
              <div class="info-item">
                <span class="info-label">单据状态</span>
                <span class="info-value">{{ currentBill.billStatus }}</span>
              </div>
              <div class="info-item">
                <span class="info-label">最终标准运费</span>
                <span class="info-value">{{ formatCurrency(currentBill.finalStandardFee) }}</span>
              </div>
              <div class="info-item">
                <span class="info-label">最终折后运费</span>
                <span class="info-value">{{ formatCurrency(currentBill.finalDiscountedFee) }}</span>
              </div>
              <div class="info-item">
                <span class="info-label">最终总费用</span>
                <span class="info-value">{{ formatCurrency(currentBill.finalTotalFee) }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="detail-section">
          <div class="section-header">
            <span class="section-title">运单明细</span>
            <el-button type="text" icon="el-icon-arrow-up" @click="toggleDetailSection('orderDetail')" />
          </div>
          <div v-show="detailSections.orderDetail" class="section-content">
            <div class="detail-filter">
              <el-form :inline="true" :model="detailFilterForm" class="detail-filter-form">
                <el-form-item label="差异原因">
                  <el-select v-model="detailFilterForm.diffReason" multiple placeholder="请选择差异原因" style="width: 180px;">
                    <el-option v-for="option in diffReasonOptions" :key="option.value" :label="option.label" :value="option.value" />
                  </el-select>
                </el-form-item>
                <el-form-item label="快递单号">
                  <el-input v-model="detailFilterForm.expressNumber" placeholder="输入快递单号" style="width: 200px;" />
                </el-form-item>
                <el-form-item label="账单状态">
                  <el-select v-model="detailFilterForm.billStatus" multiple placeholder="请选择状态" style="width: 150px;">
                    <el-option label="未关账" value="未关账" />
                    <el-option label="已关账" value="已关账" />
                    <el-option label="已开票" value="已开票" />
                  </el-select>
                </el-form-item>
                <el-form-item label="账单批次号">
                  <el-input v-model="detailFilterForm.billBatchNo" placeholder="输入账单批次号" style="width: 180px;" />
                </el-form-item>
                <el-form-item label="账单日期">
                  <el-date-picker
                    v-model="detailFilterForm.billDate"
                    type="date"
                    placeholder="选择日期"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    style="width: 150px;"
                  />
                </el-form-item>
                <el-form-item label="公司名称">
                  <el-input v-model="detailFilterForm.companyName" placeholder="输入公司名称" style="width: 180px;" />
                </el-form-item>
                <el-form-item>
                  <el-button @click="resetDetailFilter">重置</el-button>
                  <el-button type="primary" @click="searchDetail">搜索</el-button>
                </el-form-item>
              </el-form>
            </div>

            <el-table
              :data="orderDetails"
              border
              style="width: 100%"
              height="300"
            >
              <el-table-column type="selection" width="50" />
              <el-table-column
                prop="status"
                label="状态"
                width="120"
              >
                <template slot-scope="scope">
                  <el-tag :type="getStatusType(scope.row.status)">
                    {{ scope.row.status }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column
                prop="diffReason"
                label="差异原因"
                width="150"
              />
              <el-table-column
                prop="billDate"
                label="账单日期"
                width="120"
              />
              <el-table-column
                prop="brand"
                label="BZ_品牌"
                width="120"
              />
              <el-table-column
                prop="expressNumber"
                label="快递单号"
                width="180"
              />
              <el-table-column
                prop="warehouseName"
                label="BZ_仓库名称"
                width="120"
              />
              <el-table-column
                prop="shopName"
                label="BZ_店铺名称"
                width="120"
              />
              <el-table-column
                prop="transportName"
                label="BZ_物流商名称"
                width="120"
              />
              <el-table-column
                prop="transportCode"
                label="物流商编码"
                width="120"
              />
              <el-table-column
                prop="shipTime"
                label="BZ_发货时间"
                width="160"
              />
              <el-table-column
                prop="dataSourcing"
                label="BZ_DataSourcing"
                width="120"
              />
              <el-table-column
                prop="orderType"
                label="BZ_订单类型"
                width="120"
              />
              <el-table-column
                label="操作"
                width="100"
              >
                <template slot-scope="scope">
                  <el-button type="text" class="action-link" @click="viewFeeDetail(scope.row)">
                    费用详情
                  </el-button>
                </template>
              </el-table-column>
            </el-table>

            <div class="pagination-area">
              <div class="page-size-selector">
                <span>每页</span>
                <el-select v-model="detailPagination.pageSize" size="small" style="width: 60px;">
                  <el-option :label="'20'" :value="20" />
                  <el-option :label="'30'" :value="30" />
                  <el-option :label="'50'" :value="50" />
                </el-select>
                <span>条</span>
              </div>
              <div class="pagination">
                <el-pagination
                  @size-change="handleDetailSizeChange"
                  @current-change="handleDetailCurrentChange"
                  :current-page="detailPagination.currentPage"
                  :page-size="detailPagination.pageSize"
                  layout="prev, pager, next, jumper"
                  :total="detailPagination.total"
                />
              </div>
              <div class="total-info">
                共 {{ detailPagination.total }} 条
              </div>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="detailDialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>

    <el-dialog
      v-model="feeDetailDialogVisible"
      title="费用详情"
      width="80%"
      :close-on-click-modal="false"
    >
      <div class="fee-detail">
        <div class="fee-section">
          <h3>运单基本信息</h3>
          <div class="basic-info-grid">
            <div class="basic-info-item">
              <span class="basic-info-label">快递单号</span>
              <span class="basic-info-value">{{ currentOrderDetail.expressNumber }}</span>
            </div>
            <div class="basic-info-item">
              <span class="basic-info-label">物流商名称</span>
              <span class="basic-info-value">{{ currentOrderDetail.transportName }}</span>
            </div>
            <div class="basic-info-item">
              <span class="basic-info-label">订单类型</span>
              <span class="basic-info-value">{{ currentOrderDetail.orderType }}</span>
            </div>
            <div class="basic-info-item">
              <span class="basic-info-label">DataSourcing</span>
              <span class="basic-info-value">{{ currentOrderDetail.dataSourcing }}</span>
            </div>
            <div class="basic-info-item">
              <span class="basic-info-label">仓库名称</span>
              <span class="basic-info-value">{{ currentOrderDetail.warehouseName }}</span>
            </div>
            <div class="basic-info-item">
              <span class="basic-info-label">店铺名称</span>
              <span class="basic-info-value">{{ currentOrderDetail.shopName }}</span>
            </div>
            <div class="basic-info-item">
              <span class="basic-info-label">发货时间</span>
              <span class="basic-info-value">{{ currentOrderDetail.shipTime }}</span>
            </div>
            <div class="basic-info-item">
              <span class="basic-info-label">重量</span>
              <span class="basic-info-value">{{ currentOrderDetail.weight }}</span>
            </div>
          </div>
        </div>

        <el-tabs type="border-card">
          <el-tab-pane label="费用详情">
            <el-table
              :data="feeDetails"
              border
              style="width: 100%"
            >
              <el-table-column prop="feeType" label="费项" width="200" />
              <el-table-column prop="feeAmount" label="费用金额" width="150" :formatter="formatCurrency" />
              <el-table-column prop="feeDesc" label="说明" />
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="账单详情">
            <el-table
              :data="billDetails"
              border
              style="width: 100%"
            >
              <el-table-column prop="billField" label="字段" width="200" />
              <el-table-column prop="billValue" label="值" />
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="操作详情">
            <el-table
              :data="operationDetails"
              border
              style="width: 100%"
            >
              <el-table-column prop="operationField" label="字段" width="200" />
              <el-table-column prop="operationValue" label="值" />
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="feeDetailDialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'CostBillCheck',
  data() {
    return {
      filterForm: {
        transportCode: 'SF',
        billCycle: '2026-04',
        billStatus: '',
        checkBillNo: '',
        monthlyAccount: '',
        diffReason: '',
        expressNumber: '',
        companyName: '',
        billBatchNo: ''
      },
      filterExpanded: false,
      pagination: {
        currentPage: 1,
        pageSize: 20,
        total: 1
      },
      selectedBillNos: [],
      billList: [
        {
          checkBillNo: 'HDD2026032700007',
          billCycle: '2026-04',
          monthlyAccount: '51260350519',
          transportCode: 'SF',
          transportName: '顺丰快递',
          transportOrderCount: 47,
          systemOrderCount: 45,
          billStatus: '有差异待处理',
          transportStandardFee: 1970,
          systemStandardFee: 1970,
          standardFeeDiff: 440,
          transportDiscountedFee: 1970,
          systemDiscountedFee: 1970,
          discountedFeeDiff: 440,
          transportTotalFee: 1970,
          systemTotalFee: 1970,
          totalFeeDiff: 1530,
          matchResult: '完成',
          finalStandardFee: 0,
          finalDiscountedFee: 0,
          finalTotalFee: 0
        },
        {
          checkBillNo: 'HDD2026032700007',
          billCycle: '2026-04',
          monthlyAccount: '51260350519',
          transportCode: 'SF',
          transportName: '顺丰快递',
          transportOrderCount: 47,
          systemOrderCount: 45,
          billStatus: '有差异待处理',
          transportStandardFee: 1970,
          systemStandardFee: 1970,
          standardFeeDiff: 440,
          transportDiscountedFee: 1970,
          systemDiscountedFee: 1970,
          discountedFeeDiff: 440,
          transportTotalFee: 1970,
          systemTotalFee: 1970,
          totalFeeDiff: 1530,
          matchResult: '完成',
          finalStandardFee: 0,
          finalDiscountedFee: 0,
          finalTotalFee: 0
        }
      ],
      detailDialogVisible: false,
      currentBill: {},
      detailSections: {
        billInfo: true,
        orderDetail: true
      },
      detailFilterForm: {
        diffReason: [],
        expressNumber: '',
        billStatus: [],
        billBatchNo: '',
        billDate: '',
        companyName: ''
      },
      diffReasonOptions: [
        { label: '结算系统不存在', value: '结算系统不存在' },
        { label: '非宝尊月结', value: '非宝尊月结' },
        { label: '产品类型差异', value: '产品类型差异' },
        { label: '物流商运单不存在', value: '物流商运单不存在' },
        { label: '运单卡接口', value: '运单卡接口' },
        { label: '运费未正常计算', value: '运费未正常计算' },
        { label: '标准运费差异', value: '标准运费差异' },
        { label: '计费重量差异', value: '计费重量差异' },
        { label: '折后运费差异', value: '折后运费差异' },
        { label: '服务费差异', value: '服务费差异' }
      ],
      orderDetails: [
        {
          status: '有差异待处理',
          diffReason: '运单卡接口',
          billDate: '2026-04-16',
          brand: 'NIKE-大陆',
          expressNumber: 'SF5192529203170',
          warehouseName: '',
          shopName: '',
          transportName: '',
          transportCode: 'SF',
          shipTime: '2026-04-16 17:25:05',
          dataSourcing: '',
          orderType: '销售单',
          weight: 1.5
        }
      ],
      detailPagination: {
        currentPage: 1,
        pageSize: 20,
        total: 1
      },
      feeDetailDialogVisible: false,
      currentOrderDetail: {},
      feeDetails: [
        { feeType: '标准运费', feeAmount: 25.00, feeDesc: '' },
        { feeType: '燃油附加费', feeAmount: 2.00, feeDesc: '' },
        { feeType: '折扣率', feeAmount: 0.85, feeDesc: '85折' },
        { feeType: '折后运费', feeAmount: 22.95, feeDesc: '' }
      ],
      billDetails: [
        { billField: '月结账号', billValue: '0210974644' },
        { billField: '快递单号', billValue: 'SF5192529203170' },
        { billField: '账单类型', billValue: '月账单' },
        { billField: '业务类型', billValue: '快递运费' },
        { billField: '服务', billValue: '运费' },
        { billField: '标准运费', billValue: '25.00' },
        { billField: '折后运费', billValue: '22.95' },
        { billField: '版本号', billValue: 'V1.0' },
        { billField: '账单日期', billValue: '2026-04-16' },
        { billField: '账单推送时间', billValue: '2026-04-17 10:30:00' }
      ],
      operationDetails: [
        { operationField: '快递单号', operationValue: 'SF5192529203170' },
        { operationField: '核对单号', operationValue: 'HDD2026032700013' },
        { operationField: '标准运费', operationValue: '25.00' },
        { operationField: '折后运费', operationValue: '22.95' },
        { operationField: '总费用', operationValue: '22.95' },
        { operationField: '导入人', operationValue: '张三' },
        { operationField: '导入时间', operationValue: '2026-04-17 10:35:00' }
      ]
    }
  },
  methods: {
    toggleFilterExpand() {
      this.filterExpanded = !this.filterExpanded
    },
    handleSearch() {
      console.log('搜索条件:', this.filterForm)
    },
    handleReset() {
      this.filterForm = {
        transportCode: '',
        billCycle: '',
        billStatus: '',
        checkBillNo: '',
        monthlyAccount: '',
        diffReason: '',
        expressNumber: '',
        companyName: '',
        billBatchNo: ''
      }
    },
    handleSizeChange(size) {
      this.pagination.pageSize = size
    },
    handleCurrentChange(current) {
      this.pagination.currentPage = current
    },
    handleSelectionChange(val) {
      this.selectedBillNos = val.map(item => item.checkBillNo)
    },
    formatCurrency(row, column, cellValue) {
      if (cellValue === undefined || cellValue === null) {
        return '0.00'
      }
      return parseFloat(cellValue).toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    },
    formatCurrencyWithColor(row, column, cellValue) {
      const value = parseFloat(cellValue) || 0
      const formatted = value.toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
      if (value > 0) {
        return `<span style="color: #F56C6C">${formatted}</span>`
      } else if (value < 0) {
        return `<span style="color: #67C23A">${formatted}</span>`
      }
      return formatted
    },
    getStatusType(status) {
      switch (status) {
        case '无差异':
          return 'success'
        case '有差异待处理':
          return 'warning'
        case '有差异已处理':
          return 'primary'
        default:
          return 'info'
      }
    },
    viewDetail(row) {
      this.currentBill = row
      this.detailDialogVisible = true
    },
    toggleDetailSection(section) {
      this.detailSections[section] = !this.detailSections[section]
    },
    resetDetailFilter() {
      this.detailFilterForm = {
        diffReason: [],
        expressNumber: '',
        billStatus: [],
        billBatchNo: '',
        billDate: '',
        companyName: ''
      }
    },
    searchDetail() {
      console.log('明细搜索:', this.detailFilterForm)
    },
    handleDetailSizeChange(size) {
      this.detailPagination.pageSize = size
    },
    handleDetailCurrentChange(current) {
      this.detailPagination.currentPage = current
    },
    viewFeeDetail(row) {
      this.currentOrderDetail = row
      this.feeDetailDialogVisible = true
    },
    handleReMatch() {
      if (!this.selectedBillNos.length) {
        this.$message.warning('请先选择要重新匹配的核对单')
        return
      }
      this.$confirm('确定要重新匹配选中的核对单吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$message.success('重新匹配成功')
      })
    },
    handleImportExportResult() {
      this.$message.info('跳转至导入导出结果页面')
    },
    handleImport() {
      this.$message.info('弹出导入成本账单弹窗')
    },
    handleExport() {
      this.$message.info('导出数据')
    }
  }
}
</script>

<style scoped>
.cost-bill-check-page {
  padding: 16px;
  background-color: #f5f7fa;
  min-height: calc(100vh - 48px);
}

.filter-area {
  background-color: #fff;
  padding: 16px;
  border-radius: 4px;
  margin-bottom: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

.filter-form {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 16px;
}

.filter-form .el-form-item {
  margin-bottom: 0;
}

.filter-form .el-form-item__label {
  font-size: 13px;
  color: #606266;
}

.filter-actions {
  margin-left: auto;
  display: flex;
  gap: 8px;
}

.icon-button {
  width: 32px;
  height: 32px;
  padding: 0;
}

.action-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #fff;
  padding: 12px 16px;
  border-radius: 4px;
  margin-bottom: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

.action-bar__left,
.action-bar__right {
  display: flex;
  gap: 8px;
}

.bill-list-area {
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

.bill-list-area .el-table {
  font-size: 13px;
}

.bill-list-area .el-table th {
  background-color: #fafafa;
  font-weight: 500;
  color: #606266;
}

.action-link {
  color: #409EFF;
  font-size: 13px;
}

.pagination-area {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  border-top: 1px solid #ebeef5;
}

.page-size-selector {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #606266;
}

.total-info {
  font-size: 13px;
  color: #606266;
}

.detail-section {
  margin-bottom: 20px;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 14px;
  background-color: #f5f7fa;
  border-radius: 4px;
  margin-bottom: 14px;
}

.section-title {
  font-size: 13px;
  font-weight: 500;
  color: #303133;
}

.section-content {
  padding: 0 6px;
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
}

.info-item {
  display: flex;
  justify-content: space-between;
  padding: 8px 10px;
  background-color: #f5f7fa;
  border-radius: 4px;
  font-size: 13px;
}

.info-label {
  color: #606266;
}

.info-value {
  color: #303133;
  font-weight: 500;
}

.detail-filter {
  background-color: #f5f7fa;
  padding: 14px;
  border-radius: 4px;
  margin-bottom: 14px;
}

.detail-filter-form {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
}

.detail-filter-form .el-form-item {
  margin-bottom: 0;
}

.fee-detail {
  padding: 14px;
}

.fee-section {
  margin-bottom: 18px;
}

.fee-section h3 {
  font-size: 13px;
  font-weight: 500;
  color: #303133;
  margin-bottom: 14px;
}

.basic-info-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
}

.basic-info-item {
  display: flex;
  justify-content: space-between;
  padding: 8px 10px;
  background-color: #f5f7fa;
  border-radius: 4px;
  font-size: 13px;
}

.basic-info-label {
  color: #606266;
}

.basic-info-value {
  color: #303133;
}
</style>